export default "__VITE_ASSET__008638ba__"